import { useIntl } from "react-intl";
import { getIntegrationTypeMeta } from "../config/integrationTypeConfig";
import { AgentforceDiscoveryForm } from "./agentforce";
import AWSIntegrationForm from "./aws/AWSIntegrationForm";
import { mockFormConfig } from "./aws/AWSIntegrationForm/mockFormConfig";
import { AzureFoundryDiscoveryForm } from "./azure-foundry";
import { CopilotStudioDiscoveryForm } from "./CopilotStudio";
import { GoogleVertexDiscoveryForm } from "./gcp-vertex";
import { ServiceNowDiscoveryForm } from "./servicenow";

interface IntegrationFormViewProps {
  selectedType: string;
  integrationId?: string;
  formData?: Record<string, unknown>;
  isFormValid?: boolean;
  onFormDataChange: (data: Record<string, unknown>) => void;
  onClose: () => void;
}

export function IntegrationFormView({
  selectedType,
  integrationId,
  onFormDataChange,
  onClose,
}: IntegrationFormViewProps) {
  const intl = useIntl();
  const form = getIntegrationTypeMeta(selectedType)?.form ?? "AWS";
  const id = integrationId ? Number(integrationId) : undefined;

  switch (form) {
    case "GCPVertex":
    case "GooglePlatform":
      return (
        <GoogleVertexDiscoveryForm
          integrationType={selectedType}
          integrationId={id}
          onFormDataChange={onFormDataChange}
          onClose={onClose}
        />
      );
    case "Agentforce":
      return (
        <AgentforceDiscoveryForm
          integrationType={selectedType}
          integrationId={id}
          onFormDataChange={onFormDataChange}
          onClose={onClose}
        />
      );
    case "CopilotStudio":
      return (
        <CopilotStudioDiscoveryForm
          integrationType={selectedType}
          integrationId={id}
          onFormDataChange={onFormDataChange}
          onClose={onClose}
        />
      );
    case "ServiceNow":
    case "NowAssist":
      return (
        <ServiceNowDiscoveryForm
          integrationType={selectedType}
          integrationId={id}
          onFormDataChange={onFormDataChange}
          onClose={onClose}
        />
      );
    case "AzureFoundry":
    case "AzurePlatform":
      return (
        <AzureFoundryDiscoveryForm
          integrationType={selectedType}
          integrationId={id}
          onFormDataChange={onFormDataChange}
          onClose={onClose}
        />
      );
    case "AWS":
    case "AWSPlatform":
    default:
      return (
        <AWSIntegrationForm
          config={{
            ...mockFormConfig,
            pageTitle: integrationId
              ? intl.formatMessage({
                  id: "Jq276c",
                  defaultMessage: "Edit Integration",
                  description: "Page title for edit integration form",
                })
              : intl.formatMessage({
                  id: "YYujKG",
                  defaultMessage: "Add Integration",
                  description: "Page title for add integration form",
                }),
            provider: selectedType,
          }}
          integrationId={id}
          onClose={onClose}
          onSubmit={(data) => {
            onFormDataChange(data);
          }}
        />
      );
  }
}
